import styled from 'styled-components';
import device from '../../../../styles/mediaSizes';

// 1-SECTION
export const HeroBannerCancer = styled.div`
  .hero-banner-wrapper {
    .hero-left-col {
      width: 33%;
    }
    .hero-right-col {
      width: 67%;
    }
  }

  @media ${device.sm} {
    .hero-banner-wrapper {
      .hero-left-col {
        width: 100%;
      }
      .hero-right-col {
        width: 100%;
      }
    }
  }
`;

// 2-SECTION
export const ArticleVideo = styled.div`
  .pure-article-wrapper {
    .title-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .heading-2.regular {
        margin-bottom: 90px;
        text-align: left;
      }
    }
    .article-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .article-left-col {
        width: 48%;
      }
      .article-right-col {
        width: 48%;
        padding-right: 45px;
      }
    }
    .side-text-wrapper {
      margin-bottom: 20px;
      .side-text-light {
        color: #70b97a;
        font-family: Prompt, sans-serif;
        font-size: 24px;
        line-height: 34px;
        font-weight: 600;
      }
      .side-text {
        color: #5f5a6a;
        font-family: Prompt, sans-serif;
        font-size: 24px;
        line-height: 34px;
        font-weight: 300;
      }
    }
    .bold-text {
      font-weight: 500;
      font-size: 20px;
    }
    .tail-text {
      margin-top: 50px;
    }
    @media ${device.lg} {
    }
    @media ${device.md} {
      & {
        .title-wrapper {
          .decorated-title-wrapper {
            img {
            }
            .heading-2.decorated {
              padding-left: 30px;
              padding-right: 65px;
              margin-bottom: 55px;
            }
          }
          .heading-2.regular {
          }
        }

        .article-wrapper {
          .article-right-col {
            padding-right: 35px;
          }
          .article-left-col {
            padding-right: 35px;
          }
          .side-text-wrapper {
            .side-text-light,
            .side-text {
              font-size: 14px;
              line-height: 24px;
            }
          }

          .bold-text {
            font-weight: 500;
            font-size: 17px;
          }
        }

        .tail-text {
          margin-top: 25px;
        }
      }
    }
    @media ${device.sm} {
      & {
        .title-wrapper {
          .decorated-title-wrapper {
            img {
              display: none;
            }
            .heading-2.decorated {
              padding-left: 0;
              margin-bottom: 35px;
              border: none;
            }
          }
          .heading-2.regular {
          }
        }

        .article-wrapper {
          .article-left-col {
            width: 100%;
            padding-right: 0;
            margin-bottom: 12px;
          }
          .article-right-col {
            width: 100%;
            padding-right: 0;
          }
          .side-text-wrapper {
            .side-text-light,
            .side-text {
              font-size: 14px;
              line-height: 20px;
              font-weight: 300;
            }
          }
          .bold-text {
            font-weight: 500;
            font-size: 13px;
          }
        }
        .tail-text {
          margin-top: 25px;
        }
      }
    }
  }
  p {
    .text-button {
      color: white !important;
    }
  }
`;

// 3-SECTION
export const PicTextCTO = styled.div``;

// 4-SECTION
export const RiskOfCancer = styled.div``;

// 5-SECTION
export const RunInYourFamily = styled.div`
  .divider-wrapper {
    .divider-text {
      background-color: ${({ bgColor }) => bgColor};
      color: ${({ theme }) => theme.mainColor};
    }
  }
  .section-title-wrapper {
    margin-bottom: 50px;
    .heading-1 {
    }
    .heading-2 {
      font-size: 50px;
      line-height: 1.7;
      text-align: center;
      margin-bottom: 15px;
    }
    .heading-4 {
      text-align: center;
    }
    .text-block-2 {
      margin: auto;
      text-align: center;
      width: 80%;
    }

    @media ${device.lg} {
      & {
        .heading-1 {
        }
        .heading-2 {
          margin-bottom: 15px;
          font-size: 50px;
          text-align: center;
        }
        .heading-4 {
          text-align: center;
        }
        .text-block-2 {
          margin: 0 auto;
          text-align: center;
          width: 80%;
        }
      }
    }
    @media ${device.md} {
      & {
        margin-bottom: 50px;
        .heading-1 {
        }
        .heading-2 {
          font-size: 40px;
          line-height: 1.5;
        }
        .heading-4 {
        }
        .text-block-2 {
          width: 90%;
          line-height: 22px;
        }
      }
    }
    @media ${device.sm} {
      & {
        margin-bottom: 35px;
        .heading-1 {
          text-align: center;
          margin-bottom: 15px;
        }
        .heading-2 {
          font-size: 35px;
          text-align: center;
          margin-bottom: 15px;
        }
        .heading-4 {
          text-align: center;
        }
        .text-block-2 {
          margin: 0 auto;
          text-align: center;
          width: 100%;
        }
      }
    }
  }
`;

// 6-SECTION
export const PicTexHelpOfGenetics = styled.div`
  .pic-text-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin: 0 -15px;
    .pic-col {
      width: 48%;
      .inner-img {
        width: 80%;
        border-radius: 9px;
      }
      .regular-img {
        display: inline-block;
      }
      .mobile-img {
        display: none;
      }
    }
    .text-col {
      width: 50%;
      .text-group {
        margin-bottom: 35px;
        .heading-1 {
        }
        .heading-2 {
        }
        .heading-4 {
          color: #5f5a6a;
        }
      }
    }
    @media ${device.sm} {
      & {
        margin: 0;
        .pic-col {
          width: 100%;
          margin-bottom: 35px;
          .inner-img {
          }
          .regular-img {
            display: none;
          }
          .mobile-img {
            display: block;
            margin: auto;
          }
        }
        .text-col {
          width: 100%;
          .text-group {
            margin-bottom: 20px;
          }
        }
      }
    }
  }
`;

// 7-SECTION
export const BenefitsOfTesting = styled.div`
  .section-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .col-1 {
      width: 48%;
    }
    .col-2 {
      width: 45%;
      margin-top: 1em;
    }
    @media ${device.lg} {
    }
    @media ${device.md} {
    }
    @media ${device.sm} {
      & {
        .col-1,
        .col-2 {
          width: 100%;
        }
      }
    }
  }
`;

// 8-SECTION
export const HowItWorks = styled.div`
  .section-title-wrapper {
    margin-bottom: 60px;
    .title {
      text-align: center;
    }
    .description {
      margin: 0 auto;
      text-align: center;
      width: 59%;
    }
    @media ${device.lg} {
    }
    @media ${device.md} {
      & {
        .description {
          width: 90%;
        }
      }
    }
    @media ${device.sm} {
    }
  }
`;

// 9-SECTION
export const PicTextPrivacy = styled.div`
  .pic-text-wrapper {
    .pic-col {
      width: 41.6%;
      .inner-img {
        border-radius: 0;
        width: 100%;
      }
      .regular-img {
        display: inline-block;
      }
      .mobile-img {
        display: none;
      }
    }
    .text-col {
      .text-group {
        .heading-1 {
        }
        .heading-2 {
        }
        .heading-4 {
          color: #5f5a6a;
        }
      }
    }

    @media ${device.sm} {
      & {
        .pic-col {
          width: 100%;
          .inner-img {
          }
          .regular-img {
            display: inline-block;
          }
          .mobile-img {
            display: none;
          }
        }
        .text-col {
          width: 100%;
          .text-group {
            .heading-1 {
            }
            .heading-2 {
            }
            .heading-4 {
              color: #5f5a6a;
            }
          }
        }
      }
    }
  }
`;

// 10-SECTION
export const FaqArea = styled.div`
  .faq-wrapper {
    .section-title-wrapper {
      .title {
      }
    }
    .accordion {
      .accordion-item {
        .accordion-header {
          .accordion-button {
            background: ${({ bgColor }) => bgColor};
            &:after,
            &.collapsed:after {
            }
            &.collapsed:after {
              background-image: url(/images/decor/faq_open_${({ theme }) => theme.themeColor}.svg);
            }
            &:after {
              background-image: url(/images/decor/faq_close_${({ theme }) => theme.themeColor}.svg);
            }
            &:focus {
            }
            &:focus:not(.collapsed) {
            }
            &:not(.collapsed) {
              background: ${({ bgColor }) => bgColor};
              color: ${({ theme }) => theme.mainColor};
            }
          }
        }
        .accordion-body {
        }
      }
    }
  }
`;
